import "core-js/modules/es.function.name.js";
import { globalErrors } from '~/core/constants/errors';
import { HttpStatusCode } from '~/core/enums';
import { ymGoal } from '~/core/utils/yandexReachGoal';
import useMainStore from '~/stores/useMainStore';
export default defineComponent({
  name: 'Error',
  props: {
    error: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  setup: function setup(props) {
    var mainStore = useMainStore();
    var $route = useRoute();
    var $router = useRouter();
    var errorObj = computed(function () {
      var code = props.error.statusCode;
      if (code === HttpStatusCode.Unauthorized || code === HttpStatusCode.Forbidden || code === HttpStatusCode.NotFound) {
        return globalErrors[code];
      }
      return globalErrors[HttpStatusCode.InternalServerError];
    });
    var shouldShowActionButton = computed(function () {
      return Boolean(errorObj.value.buttonText) && !($route.name === 'index' && errorObj.value.buttonText === 'На главную');
    });
    onBeforeMount(function () {
      mainStore.isLayoutError = true;
      if (errorObj.value.code === HttpStatusCode.NotFound) {
        ymGoal('click404');
      }
    });
    onBeforeUnmount(function () {
      mainStore.isLayoutError = false;
    });
    function handleButtonClick() {
      switch (errorObj.value.code) {
        case HttpStatusCode.Unauthorized:
          ymGoal('unauthorized');
          $router.push({
            name: 'authorization'
          });
          return;
        case HttpStatusCode.InternalServerError:
          ymGoal('internalServerError');
      }
      $router.push({
        name: 'index'
      });
    }
    return {
      errorObj: errorObj,
      shouldShowActionButton: shouldShowActionButton,
      handleButtonClick: handleButtonClick
    };
  }
});